<template>
  <div class="choose-workshop-header">
    <b-row align-h="between" class="flex-grow-1">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model.trim="form.workshopName"
              type="search"
              :placeholder="
                $l('form_placeholder_keyword') ||
                  '车间名称/车间编码 搜索...'
              "
              @keyup.enter="query"
            />
            <b-input-group-append>
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  workshopName: '',
}

export default {
  data() {
    return {
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', { ...this.form })
    },
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>

<style lang="scss" scoped>
.choose-workshop-header {
  display: flex;
  align-items: center;
  padding: 14px 0;
}
</style>
